import { Season } from '@shared/constants';
import { Cls, Emo } from 'app/constants';
import { toSeasonWeekID } from 'helpers/IdHelpers';
import { GameWeek, SeasonWeekID } from 'types/Games.types';

export type CategoryRankingsLoaderPayload = {
  seasonWeekID: SeasonWeekID;
};

export const categoryRankingsLoader = async ({ params }: any): Promise<CategoryRankingsLoaderPayload | Response> => {
  const msg = `params.yearId %c ${params.yearId} %c params.weekId %c ${params.weekId} %c`;

  console.log(`${Emo.eyes} %c categoryRankingsLoader %c ${msg}`, Cls.Loc, '', Cls.Val, '', Cls.Val, '');
  const seasonWeekID = toSeasonWeekID(params.yearId ?? Season.Season2025, params.weekId ?? GameWeek.Week1);

  return {
    seasonWeekID,
  };
};
